<template>
  <div class="mt-6 flex items-center justify-end gap-x-6">
    <button type="button" @click="onCancel" class="text-sm/6 font-semibold text-gray-900">{{ $gettext("Annuler") }}</button>
    <button type="button" @click="onSubmit" class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">{{ $gettext("Enregistrer") }}</button>
  </div>
</template>

<script setup>
const emits = defineEmits(["cancel", "submit"]);

const onCancel = (() => {
  emits("cancel");
});

const onSubmit = (() => {
  emits("submit");
});
</script>
